import React from "react";
import "./style/viechifco.css"
import guillemet from "../assets/lavieachifco/guillemet.png"
import Slider from "react-slick";
import axios from 'axios';
const Opinion = props => (
<div>
<p className="StyleParag">
    « {props.opinion.Description} »
</p>
<div style={{ marginTop: "3%" }}>
    <p className="Auteur">{props.opinion.Name}, {props.opinion.Position} </p>
</div>
<div>
  <p className="SousAuth">{props.opinion.Company}</p>
</div>
</div>
)
class VieChifco extends React.Component {
    constructor(props) {
        super(props);
      this.state = {
       
        opinions :[],
        company:'CHIFCO'
    };
      }
    
    componentDidMount() {
    axios.get(`${process.env.REACT_APP_SERVER}`+'/opinions')
    .then(response => {
      this.setState({ opinions:response.data})
    })
    .catch((error) => {
      console.log(error);
    })
    }
    
    opinionList() {
    return this.state.opinions.map(currentopinion => {
      if (currentopinion.Company == this.state.company){
      return <Opinion opinion={currentopinion}  key={currentopinion._id}/>;
      }
    })
    }
    render() {
        var settings = {
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 0,
            adaptiveHeight:true,
        };
        return (
            <div>
                <div className="BackVieChifco">
                    <div>
                        <h2 className="titlePage">la vie à chifco</h2>
                    </div>
                   
                    <div id="slidediv">
                   
                        <center>
                        <div id="guillementPos">
                            <img src={guillemet} alt="" />
                        </div>
                            <Slider {...settings}>
                            {this.opinionList()}
                            </Slider>
                        </center>
                    </div>
                </div>
            </div>

        );
    }
}
export default VieChifco;


// WEBPACK FOOTER //
// ./src/home/viechifco.js